import React, { useContext, useEffect, useMemo } from 'react'
import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { Context as PortfolioContext } from '../../contexts/portfolio'
import { isMobile } from 'react-device-detect'
import HelpRounded from '@material-ui/icons/HelpRounded'
import circleArrowUpSolid from '../../assets/images/circleArrowUpSolid.svg'
import circleArrowDownSolid from '../../assets/images/circleArrowDownSolid.svg'
import iconCalculator from '../../assets/images/calculator.svg'
import colorWhatIfLow from '../../assets/images/colorWhatIfLow.svg'
import colorWhatIfAver from '../../assets/images/colorWhatIfAver.svg'
import colorWhatIfAbo from '../../assets/images/colorWhatIfAbo.svg'
import colorWhatIfHigh from '../../assets/images/colorWhatIfHigh.svg'
import colorWhatIfCurrent from '../../assets/images/colorWhatIfCurrent.svg'
import colorWhatIfNew from '../../assets/images/colorWhatIfNew.svg'
import RotateLeftIcon from '@material-ui/icons/RotateLeft'
import {
  InputScenario2,
  InputTypeBanks,
  InputTypeInsurance,
  InputTypeNonFinancials,
  InputTypeRealEstate,
} from './ScenarioRenderType'
import WhatIfDataTooltipModal from '../../components/WhatIfDataTooltipModal'
import SpinnerIcon from '../../assets/images/spinner.gif'
import {
  ValueTypeBanks,
  ValueTypeInsurance,
  ValueTypeNonFinancials,
  ValueTypeRealEstate,
} from './ScenarioRenderValueType'
import ScenarioAmChart from './ScenarioAmChart'
import ComparisonChartD3 from './ComparisonChartD3'
let _ = require('lodash')

const useStyles = makeStyles({
  subheading: {
    marginBottom: 10,
    fontSize: 16,
    color: '#474747',
    fontWeight: 600,
  },
  marketContextContainer: {
    borderTop: 'unset',
    background: '#fff',
    margin: 'unset !important',
    width: '100% !important',
  },
  chartContainerMobile: {
    margin: 'auto',
    paddingBottom: '5px !important',
  },
  lgBanner: {
    height: '100%',
    width: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toolTip: {
    color: '#8D9CB1',
    width: 20,
    height: 20,
    fontSize: 20,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  toolTipUpDown: {
    color: '#8D9CB1',
    width: 18,
    height: 18,
    fontSize: 18,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  head: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '50px',
    weight: '100%',
  },
  mobileHead: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #DFE4EB',
  },
  gridBorder: {
    marginTop: '10px',
  },
  gridCreditStress: {
    padding: '10px',
    borderRight: '1px solid #DFE4EB',
    maxWidth: '12.666667% !important',
    flexBasis: '13.666667%',
  },
  gridScenario2: {
    padding: '0 10px',
  },
  gridPeerComparison: {
    padding: '10px',
  },
  titleHead: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.3,
    height: 36.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
  },
  // Scenario1
  gridScenario1: {
    // padding: '10px 0',
    // borderRight: '1px solid #DFE4EB',
  },
  titleHeadScenario: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    color: '#181818',
  },
  contentScenario: {
    // fontSize: 16,
    // backgroundColor: '#EDF2F7',
    // border: '1px solid #DFE4EB',
    // borderRadius: '5px'
  },
  contentViewStep: {
    fontSize: 16,
    backgroundColor: '#EDF2F7',
    border: '1px solid #DFE4EB',
    borderRadius: '5px',
  },
  titleStep: {
    padding: '16px',
  },
  titleTextStep: {
    fontColor: '#181818',
    fontSize: 14,
    fontWeight: 700,
  },
  titleValueStep: {
    marginLeft: '10px',
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    padding: '2px 12px 2px 12px',
    height: '26px',
    fontSize: 14,
    color: '#474747',
    fontWeight: 600,
  },
  titleGreenValue: {
    backgroundColor: '#d0ead7',
    color: '#32AE6C',
  },
  titleRedValue: {
    backgroundColor: '#eacbcf',
    color: '#DE3131',
  },
  itemCSM: {
    // marginTop: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 36.5,
  },
  contentPeerChart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontSize: 14,
  },
  titlePeerChart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    maxWidth: '30% !important',
  },
  titleGridPeerComD3parison: {
    color: '#1B3963',
    fontSize: '12px',
    fontWeight: '500',
  },
  spinnerIcon: {
    width: 20,
    marginLeft: 8,
  },
  button: {
    color: '#fff',
    backgroundColor: '#1B3963',
    width: 'auto',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    maxWidth: 160,
    fontSize: 12,
    fontHeight: 18,
    height: 30,
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  contentInputScenario: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  divInputSearch: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  inputSearch: {
    width: 'calc(100% - 140px)',
    fontSize: 14,
  },
  contentStep: {
    maxHeight: '530px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '10px',
      backgroundColor: '#EDF2F7',
    },

    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#C1CFDF',
      width: '2px',
      height: '10px',
      border: '3px solid #C1CFDF',
    },
  },
  contentStep1: {
    maxHeight: '230px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '10px',
      backgroundColor: '#EDF2F7',
    },

    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#C1CFDF',
      width: '2px',
      height: '10px',
      border: '3px solid #C1CFDF',
    },
  },
  buttonStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 54,
    padding: '12px 16px 12px 16px',
  },
  contentComparisonChartD3: {
    borderLeft: '1px solid #C1CFDF',
    paddingLeft: '10px',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
  },
  resetBtn: {
    marginRight: '20px',
    background: '#fff',
    width: 'auto',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    maxWidth: 160,
    fontSize: 12,
    fontHeight: 18,
    height: 30,
    '&.MuiButton-root.Mui-disabled': {
      color: '#1B3963 !important',
    },
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
    '& img': {
      marginRight: 7,
      width: 14,
      color: '#474747',
    },
  },
})

const WhatIfScenarioAnalysis = () => {
  const classes = useStyles()
  const { state, calculateWhatIf, clearDataCalculateWhatIf } = useContext(
    PortfolioContext,
  )
  const [showWhatIf, setShowWhatIf] = React.useState(false)
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const [paramCalculate1, setParamCalculate1] = React.useState({
    default_point: {},
  })
  const [dataValueChange1, setDataValueChange1] = React.useState([])

  const [paramCalculate2, setParamCalculate2] = React.useState({})
  const [isResetData, setIsResetData] = React.useState(false)
  const [typeLoading, setTypeLoading] = React.useState(null)
  const [isShowStage2, setIsShowStage2] = React.useState(false)
  const convertDataScenario = value => {
    if (value === null) {
      return null
    } else {
      let result = Number(parseFloat((value ?? 0) * 100).toFixed(2))
      return ' ' + result + '%'
    }
  }
  const resetDataCalculate = () => {
    setIsResetData(true)
    setIsShowStage2(false)
    clearDataCalculateWhatIf()
    setParamCalculate2({})
  }
  const calculateScenario1 = () => {
    setTypeLoading('input1')
    if (isShowStage2) {
      calculateWhatIf({
        data: paramCalculate2,
        scenario_type: 'input1_stage2',
        date: state?.whatIfData?.date,
        ticker: state?.whatIfData?.ticker,
        type: 'stage2',
        payload: state?.whatIfData?.payloadOutput ?? {},
      })
    } else {
      calculateWhatIf({
        data: paramCalculate1,
        scenario_type: 'input1',
        date: state?.whatIfData?.date,
        ticker: state?.whatIfData?.ticker,
        type: 'stage1',
        bfaiRating: state?.whatIfData?.bfaiRating,
      })
    }
    setIsShowStage2(true)
  }

  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  const flagChangeScenario1 = useMemo(() => {
    let flag = false
    Object.values(paramCalculate1).forEach(it => {
      if (typeof it !== 'object' && it != 0) {
        flag = true
      }
      if (typeof it === 'object') {
        Object.values(it).forEach(iu => {
          if (iu != 0) {
            flag = true
          }
        })
      }
    })
    return flag
  }, [paramCalculate1])

  const flagChangeScenario2 = useMemo(() => {
    let flag = false
    Object.values(paramCalculate2).forEach(it => {
      if (it != 0) {
        flag = true
      }
    })
    if (isShowStage2) {
      flag = true
    }
    return flag
  }, [paramCalculate2, isShowStage2])

  useEffect(() => {
    if (typeof state?.whatIfDataDetail?.scenario_1_fields === 'object') {
      let paramNull = {
        default_point: {},
      }
      let flag = false
      Object.keys(state?.whatIfDataDetail?.scenario_1_fields).forEach(
        attribute => {
          if (state?.whatIfDataDetail?.scenario_1_fields[attribute] === null) {
            flag = true
            if (
              attribute === 'close' ||
              attribute === 'vol_forecast_annualised'
            ) {
              paramNull[attribute] = 0
            } else {
              if (paramNull?.default_point) {
                paramNull.default_point[attribute] = 0
              }
            }
          }
          if (flag) {
            setParamCalculate1(paramNull)
          }
        },
      )
    }
  }, [state?.whatIfDataDetail?.scenario_1_fields])

  useEffect(() => {
    if (typeof state?.whatIfDataDetail?.scenario_2_fields === 'object') {
      let paramNull = {}
      let flag = false
      Object.keys(state?.whatIfDataDetail?.scenario_2_fields).forEach(
        attribute => {
          if (state?.whatIfDataDetail?.scenario_2_fields[attribute] === null) {
            flag = true
            paramNull[attribute] = 0
          }
          if (flag) {
            setParamCalculate2(paramNull)
          }
        },
      )
    }
  }, [state?.whatIfDataDetail?.scenario_2_fields])

  return (
    <section className={'session-what-if'}>
      <div
        className={isMobile ? classes.mobileHead : classes.head}
        style={{ paddingBottom: '13px' }}
      >
        <div className={classes.leftSection}>
          <Typography className={classes.title} style={{ fontSize: 20 }}>
            What If Scenario
          </Typography>
          <HelpRounded
            className={classes.toolTip}
            key="1"
            onClick={() => handleClickOpenTooltip()}
          />
          {showWhatIf ? (
            <img
              src={circleArrowUpSolid}
              className={classes.toolTipUpDown}
              onClick={() => setShowWhatIf(false)}
            />
          ) : (
            <img
              src={circleArrowDownSolid}
              className={classes.toolTipUpDown}
              onClick={() => setShowWhatIf(true)}
            />
          )}
        </div>
      </div>

      {showWhatIf && (
        <Grid
          className={classes.marketContextContainer}
          container
          spacing={3}
          style={{ display: `${showWhatIf ? 'block' : 'none'}` }}
        >
          <Grid container className={classes.gridBorder}>
            <Grid item xs={4} sm={4} className={classes.gridScenario1}>
              <div className={classes.titleHeadScenario}>
                <span>Scenario calculation</span>
              </div>
              <div className={classes.contentScenario}>
                {state?.whatIfData?.csmCalculate !== 0 &&
                  !state?.whatIfData?.csmCalculate && (
                    <div className={classes.contentViewStep}>
                      <div className={classes.titleStep}>
                        <span className={classes.titleTextStep}>STEP 1</span>
                        <span className={classes.titleValueStep}>
                          CSM =
                          {convertDataScenario(
                            state?.whatIfData?.csmCalculate,
                          ) ?? ' 0 %'}
                        </span>
                      </div>
                      {/* content input 1 */}
                      <div className={classes.contentStep}>
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'real_estate' && (
                            <InputTypeRealEstate
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              setParamCalculate={setParamCalculate1}
                              isResetData={isResetData}
                              setIsResetData={setIsResetData}
                              stage={'stage1'}
                              flagChangeScenario2={flagChangeScenario2}
                              setDataValueChange1={setDataValueChange1}
                            />
                          )}
                        {!!state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'insurance' && (
                            <InputTypeInsurance
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              setParamCalculate={setParamCalculate1}
                              isResetData={isResetData}
                              setIsResetData={setIsResetData}
                              flagChangeScenario2={flagChangeScenario2}
                              setDataValueChange1={setDataValueChange1}
                            />
                          )}
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'banks' && (
                            <InputTypeBanks
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              setParamCalculate={setParamCalculate1}
                              isResetData={isResetData}
                              setIsResetData={setIsResetData}
                              flagChangeScenario2={flagChangeScenario2}
                              setDataValueChange1={setDataValueChange1}
                            />
                          )}
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type ===
                            'non-financials' && (
                            <InputTypeNonFinancials
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              setParamCalculate={setParamCalculate1}
                              isResetData={isResetData}
                              setIsResetData={setIsResetData}
                              flagChangeScenario2={flagChangeScenario2}
                              setDataValueChange1={setDataValueChange1}
                            />
                          )}
                      </div>

                      {/* buttom action */}
                      <div className={classes.buttonStep}>
                        {(flagChangeScenario1 || flagChangeScenario2) && (
                          <Button
                            onClick={() => {
                              resetDataCalculate()
                            }}
                            startIcon={<RotateLeftIcon />}
                            className={classes.resetBtn}
                            variant="outlined"
                            color="primary"
                            disabled={state?.whatIfCalculateLoading}
                          >
                            Reset
                          </Button>
                        )}
                        <Button
                          onClick={calculateScenario1}
                          startIcon={
                            <img
                              src={iconCalculator}
                              style={{ height: '15px' }}
                            />
                          }
                          className={classes.button}
                          variant="outlined"
                          color="primary"
                          disabled={
                            state?.whatIfCalculateLoading ||
                            !flagChangeScenario1
                          }
                        >
                          Calculate
                          {!!state?.whatIfCalculateLoading &&
                            typeLoading === 'input1' && (
                              <img
                                alt="spinner"
                                src={SpinnerIcon}
                                className={classes.spinnerIcon}
                              />
                            )}
                        </Button>
                      </div>
                    </div>
                  )}

                {/*show content value of 1 */}
                {!!isShowStage2 &&
                  !!dataValueChange1 &&
                  (state?.whatIfData?.csmCalculate ||
                    state?.whatIfData?.csmCalculate == 0) && (
                    <div className={classes.contentViewStep}>
                      <div className={classes.titleStep}>
                        <span className={classes.titleTextStep}>STEP 1</span>
                        <span
                          className={`${classes.titleValueStep} ${
                            state?.whatIfData?.csmCalculate &&
                            (state?.whatIfData?.csmCalculate > 0
                              ? classes.titleGreenValue
                              : classes.titleRedValue)
                          }`}
                        >
                          CSM =
                          {convertDataScenario(
                            state?.whatIfData?.csmCalculate,
                          ) ?? ' 0 %'}
                        </span>
                      </div>

                      {/* content value input 1 */}
                      <div className={classes.contentStep1}>
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'real_estate' && (
                            <ValueTypeRealEstate
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              dataValueChange1={dataValueChange1}
                            />
                          )}
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'insurance' && (
                            <ValueTypeInsurance
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              dataValueChange1={dataValueChange1}
                            />
                          )}
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type === 'banks' && (
                            <ValueTypeBanks
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              dataValueChange1={dataValueChange1}
                            />
                          )}
                        {state?.whatIfDataDetail?.scenario_1_fields &&
                          state?.whatIfData?.ticker_type ===
                            'non-financials' && (
                            <ValueTypeNonFinancials
                              data={state?.whatIfDataDetail?.scenario_1_fields}
                              dataValueChange1={dataValueChange1}
                            />
                          )}
                      </div>
                    </div>
                  )}

                {!!isShowStage2 &&
                  (state?.whatIfDataDetailCalculate?.scenario_2_fields ||
                    state?.whatIfDataDetailCalculate
                      ?.scenario1_stage2_fields) && (
                    <div
                      className={classes.contentViewStep}
                      style={{ marginTop: 20 }}
                    >
                      <div className={classes.titleStep}>
                        <span className={classes.titleTextStep}>STEP 2</span>
                        <span
                          className={`${classes.titleValueStep} ${
                            state?.whatIfData?.csmCalculate2 &&
                            (state?.whatIfData?.csmCalculate2 > 0
                              ? classes.titleGreenValue
                              : classes.titleRedValue)
                          }`}
                        >
                          CSM =
                          {' ' +
                            convertDataScenario(
                              state?.whatIfData?.csmCalculate2 ?? 0,
                            )}
                        </span>
                      </div>
                      {/* content input 2 */}
                      <div className={classes.contentStep}>
                        <InputScenario2
                          dataOld={
                            state?.whatIfDataDetailCalculate
                              ?.scenario_2_fields ??
                            state?.whatIfDataDetail?.scenario_2_fields
                          }
                          dataNew={
                            state?.whatIfDataDetailCalculate
                              ?.scenario_2_fields ||
                            state?.whatIfDataDetailCalculate
                              ?.scenario1_stage2_fields
                          }
                          setParamCalculate={setParamCalculate2}
                          isResetData={isResetData}
                          setIsResetData={setIsResetData}
                          stage={'stage2'}
                          flagChangeScenario1={flagChangeScenario1}
                        />
                      </div>

                      {/* buttom action */}
                      <div className={classes.buttonStep}>
                        {(flagChangeScenario1 || flagChangeScenario2) && (
                          <Button
                            onClick={() => {
                              resetDataCalculate()
                            }}
                            startIcon={<RotateLeftIcon />}
                            className={classes.resetBtn}
                            variant="outlined"
                            color="primary"
                            disabled={state?.whatIfCalculateLoading}
                          >
                            Reset
                          </Button>
                        )}
                        <Button
                          onClick={calculateScenario1}
                          startIcon={
                            <img
                              src={iconCalculator}
                              style={{ height: '15px' }}
                            />
                          }
                          className={classes.button}
                          variant="outlined"
                          color="primary"
                          disabled={
                            state?.whatIfCalculateLoading ||
                            !flagChangeScenario1
                          }
                        >
                          Calculate
                          {!!state?.whatIfCalculateLoading &&
                            typeLoading === 'input1' && (
                              <img
                                alt="spinner"
                                src={SpinnerIcon}
                                className={classes.spinnerIcon}
                              />
                            )}
                        </Button>
                      </div>
                    </div>
                  )}
              </div>
            </Grid>
            <Grid item xs={8} sm={8} className={classes.gridScenario2}>
              <div style={{ marginLeft: '25px' }}>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    color: '#181818',
                  }}
                >
                  <span>
                    {state?.whatIfData?.bfaiRating
                      ? 'Credit Stress Measure and Ratings Summary'
                      : 'Credit Stress Measure Summary'}
                  </span>
                </div>
                {Object.keys(state?.whatIfDataDetail?.what_if_box).length >
                0 ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Grid item xs={4} sm={4}>
                      <ScenarioAmChart
                        idChart={'chartdiv'}
                        valueCms={convertDataScenario(
                          state?.whatIfData?.csm ?? null,
                        )}
                        valueRating={state?.whatIfData?.bfaiRating ?? null}
                        colorActive={'#3393F3'}
                        title={'CURRENT'}
                      />
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <ScenarioAmChart
                        idChart={'chartdiv1'}
                        valueCms={convertDataScenario(
                          state?.whatIfData?.csmCalculate ?? null,
                        )}
                        valueOld={convertDataScenario(
                          state?.whatIfData?.csm ?? null,
                        )}
                        valueRating={
                          state?.whatIfData?.bfaiCalculateRating ?? null
                        }
                        title={'STEP 1'}
                      />
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <ScenarioAmChart
                        idChart={'chartdiv2'}
                        valueCms={convertDataScenario(
                          state?.whatIfData?.csmCalculate2 ?? null,
                        )}
                        valueOld={convertDataScenario(
                          state?.whatIfData?.csm ?? null,
                        )}
                        valueRating={
                          state?.whatIfData?.bfaiCalculate2Rating ?? null
                        }
                        title={'STEP 2'}
                      />
                    </Grid>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Grid item xs={4} sm={4}>
                        <ScenarioAmChart
                          idChart={'chartdiv'}
                          valueCms={convertDataScenario(
                            state?.whatIfData?.csm ?? null,
                          )}
                          valueRating={state?.whatIfData?.bfaiRating ?? null}
                          colorActive={'#3393F3'}
                          title={'CURRENT'}
                        />
                      </Grid>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Grid item xs={4} sm={4}>
                        <ScenarioAmChart
                          idChart={'chartdiv1'}
                          valueCms={convertDataScenario(
                            state?.whatIfData?.csmCalculate ?? null,
                          )}
                          valueOld={convertDataScenario(
                            state?.whatIfData?.csm ?? null,
                          )}
                          valueRating={
                            state?.whatIfData?.bfaiCalculateRating ?? null
                          }
                          colorActive={'#00BD58'}
                          title={'STEP 1'}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4}>
                        <ScenarioAmChart
                          idChart={'chartdiv2'}
                          valueCms={convertDataScenario(
                            state?.whatIfData?.csmCalculate2 ?? null,
                          )}
                          valueOld={convertDataScenario(
                            state?.whatIfData?.csm ?? null,
                          )}
                          valueRating={
                            state?.whatIfData?.bfaiCalculate2Rating ?? null
                          }
                          colorActive={'#FB2F32'}
                          title={'STEP 2'}
                        />
                      </Grid>
                    </div>
                  </>
                )}
              </div>
              {Object.keys(state?.whatIfDataDetail?.what_if_box).length > 0 && (
                <div style={{ marginLeft: '25px', marginTop: '32px' }}>
                  <div className={classes.titleHeadScenario}>
                    <span>Peer range</span>
                  </div>
                  <div className={classes.gridScenario2}>
                    <div className={classes.titleHeadScenario}>
                      <div className={classes.flex}>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfLow}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            Low
                          </span>
                        </div>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfAver}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            Average
                          </span>
                        </div>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfAbo}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            Above average
                          </span>
                        </div>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfHigh}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            High
                          </span>
                        </div>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfCurrent}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            Current value
                          </span>
                        </div>
                        <div className={classes.divFlex}>
                          <img
                            src={colorWhatIfNew}
                            style={{ height: '15px' }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: '400',
                              marginLeft: '10px',
                            }}
                          >
                            New value
                          </span>
                        </div>
                      </div>
                    </div>
                    {Object.keys(state?.whatIfDataDetail?.what_if_box).length >
                      0 && (
                      <>
                        <div>
                          <Grid
                            id={'peer-comparison'}
                            container
                            className={classes.gridPeerComD3parison}
                          >
                            <Grid item xs={12} sm={12}>
                              {state?.whatIfDataDetail?.what_if_box?.csm &&
                                Object.keys(
                                  state?.whatIfDataDetail?.what_if_box?.csm,
                                )?.filter(it => it !== 'ranked')?.length >
                                  0 && (
                                  <div className={classes.contentPeerChart}>
                                    <Grid
                                      item
                                      xs={2}
                                      sm={2}
                                      className={classes.titlePeerChart}
                                    >
                                      <span
                                        className={
                                          classes.titleGridPeerComD3parison
                                        }
                                      >
                                        CSM
                                      </span>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={10}
                                      sm={10}
                                      className={
                                        classes.contentComparisonChartD3
                                      }
                                    >
                                      <ComparisonChartD3
                                        dataWhatIf={state?.whatIfDataDetail}
                                        dataWhatIfCalculate={
                                          state?.whatIfDataDetailCalculate
                                        }
                                        classDraw={'chartCMSPeer'}
                                        type={'csm'}
                                      />
                                    </Grid>
                                  </div>
                                )}

                              {state?.whatIfDataDetail?.what_if_box
                                ?.volatility &&
                                Object.keys(
                                  state?.whatIfDataDetail?.what_if_box
                                    ?.volatility,
                                )?.filter(it => it !== 'ranked')?.length >
                                  0 && (
                                  <div className={classes.contentPeerChart}>
                                    <Grid
                                      item
                                      xs={2}
                                      sm={2}
                                      className={classes.titlePeerChart}
                                    >
                                      <span
                                        className={
                                          classes.titleGridPeerComD3parison
                                        }
                                      >
                                        Leverage
                                      </span>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={10}
                                      sm={10}
                                      className={
                                        classes.contentComparisonChartD3
                                      }
                                    >
                                      <ComparisonChartD3
                                        dataWhatIf={state?.whatIfDataDetail}
                                        dataWhatIfCalculate={
                                          state?.whatIfDataDetailCalculate
                                        }
                                        classDraw={'chartLevPeer'}
                                        type={'volatility'}
                                      />
                                    </Grid>
                                  </div>
                                )}

                              {state?.whatIfDataDetail?.what_if_box
                                ?.asset_volatility &&
                                Object.keys(
                                  state?.whatIfDataDetail?.what_if_box
                                    ?.asset_volatility,
                                )?.filter(it => it !== 'ranked')?.length >
                                  0 && (
                                  <>
                                    <div className={classes.contentPeerChart}>
                                      <Grid
                                        item
                                        xs={2}
                                        sm={2}
                                        className={classes.titlePeerChart}
                                      >
                                        <span
                                          className={
                                            classes.titleGridPeerComD3parison
                                          }
                                        >
                                          Assets Volatility
                                        </span>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={10}
                                        sm={10}
                                        className={
                                          classes.contentComparisonChartD3
                                        }
                                      >
                                        <ComparisonChartD3
                                          dataWhatIf={state?.whatIfDataDetail}
                                          dataWhatIfCalculate={
                                            state?.whatIfDataDetailCalculate
                                          }
                                          classDraw={'chartAssetCompany'}
                                          type={'asset_volatility'}
                                        />
                                      </Grid>
                                    </div>
                                  </>
                                )}
                            </Grid>
                          </Grid>
                        </div>

                        <div className={classes.titleHeadScenario}></div>
                        {state?.whatIfDataDetail?.what_if_box
                          ?.asset_market_value &&
                          Object.keys(
                            state?.whatIfDataDetail?.what_if_box
                              ?.asset_market_value,
                          )?.filter(it => it !== 'ranked')?.length > 0 && (
                            <>
                              <div className={classes.titleHeadScenario}>
                                <div className={classes.flex}>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfHigh}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      Low
                                    </span>
                                  </div>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfAbo}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      Average
                                    </span>
                                  </div>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfAver}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      Above average
                                    </span>
                                  </div>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfLow}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      High
                                    </span>
                                  </div>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfCurrent}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      Current value
                                    </span>
                                  </div>
                                  <div className={classes.divFlex}>
                                    <img
                                      src={colorWhatIfNew}
                                      style={{ height: '15px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        marginLeft: '10px',
                                      }}
                                    >
                                      New value
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className={classes.contentPeerChart}>
                                <Grid
                                  item
                                  xs={2}
                                  sm={2}
                                  className={classes.titlePeerChart}
                                >
                                  <span
                                    className={
                                      classes.titleGridPeerComD3parison
                                    }
                                  >
                                    Assets Value
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={10}
                                  sm={10}
                                  className={classes.contentComparisonChartD3}
                                >
                                  <ComparisonChartD3
                                    dataWhatIf={state?.whatIfDataDetail}
                                    dataWhatIfCalculate={
                                      state?.whatIfDataDetailCalculate
                                    }
                                    classDraw={'chartValPeer'}
                                    type={'asset_market_value'}
                                  />
                                </Grid>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
      <WhatIfDataTooltipModal
        open={openTooltip}
        handleClose={() => {
          setOpenTooltip(false)
        }}
      />
    </section>
  )
}

export default WhatIfScenarioAnalysis
